import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { EncrDecrService } from './../../services/encr-decr.service';
import { HttpClient } from '@angular/common/http';
import { BsModalRef } from 'ngx-bootstrap';
import { environment } from '../../../environments/environment.prod';
import { saveAs } from 'file-saver';
import { ProfessionalService } from './../../services/professional.service';
import { isNumber } from '@ng-bootstrap/ng-bootstrap/util/util';
import { ContactService } from '../../services/contact.service';
let obj: ProfessionalListComponent;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}
@Component({
  selector: 'app-professional-list',
  templateUrl: './professional-list.component.html',
  styleUrls: ['./professional-list.component.css']
})
export class ProfessionalListComponent implements OnInit {

  config: any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true
  };

  listdata: any = ["ID#", "Professional Name", "Mobile#", "Email", "DOB", "Empl Type", "Company Name", "Speciality", "Reg Cost Rate", "Reg Sale Rate", "Ot Cost Rate", "Ot Sale Rate", "Dt Cost Rate", "Dt Sale Rate"];

  csvDatavalue: any = {};
  public data: Object;

  user_id: any = '';
  company_id: any = '';
  APIKEY: any = '';
  modelInfo: any = {};
  model: any = {};
  delete_contact_id: any;
  cust_status: any = '';
  statusValue: string = 'all';
  CSV_Datalist: FormGroup;
  submitted = false;
  csvRecords: any = [];
  loaderMode: any = false;
  dataList: any[];
  modalRef: BsModalRef;
  saleRate: any;
  costRate: any;
  display: any = 'none';
  show_CSV: boolean = false;
  show_ListData: boolean = true;
  csvCellName: any = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD'];

  show_browser_file: any = true;

  select_field_array: any;

  AllClassData = [];

  customerCsvPath: any = '';
  professional_id: any;
  pro_status: any;
  professional_name: any;
  filtter_customer_id: any = 'all';
  customerfiltter: object = [];
  filter_employee_type: any = 'all';
  filter_status_value: any;

  recodes: any;
  fieldrecodes: any;

  csvFileMode: any = true;
  newCSV: any;
  matchnewData: any;
  title = 'app';
  CSVRecord: any;
  @ViewChild('fileImportInput') fileImportInput: any;

  files: any;
  fileevent: any;
  emailcontentdiv: boolean = false;

  csvDataList: any;
  emptyField: any = false;
  rowBoxEmptyMsg: string;
  tableRowCount: any = 0;
  professionalList: any = [];
  isExistingRateMatch: any = true;
  finalSaveSubmitMsg: string = '';
  customerList: any = [];
  customerCsvPathWithoutSpaces: any;

  constructor(
    private http: HttpClient,
    private _contact: ContactService,
    private _router: Router,
    private toastr: ToastrService,
    private EncrDecr: EncrDecrService,
    public fb: FormBuilder,
    private _activatedroute: ActivatedRoute,
    private _professional: ProfessionalService) { }

  oppoSuitsForm = this.fb.group({
    name: ['']
  })

  // dtOptions: DataTables.Settings = {};
  dtOptionsList: DataTables.Settings = {};

  ngOnInit() {
    this.user_id = localStorage.getItem('id');
    this.company_id = localStorage.getItem('company_id');
    this.APIKEY = localStorage.getItem('APIKEY');

    this._activatedroute.params.subscribe(params => {
      this.statusValue = params['status'];
      if (params['status'] == 'active') {
        this.statusValue = 'Active';
      }
      if (params['status'] == 'inactive') {
        this.statusValue = 'Inactive';
      }
    });

    //code By Archana 5 may 2022
    const customerModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'active',
    }

    this.dataTableForProfessional();
    // code by Archana 6may 2022 for professional customer list
    this._professional.customerprofessionalListFilter(customerModal)
      .subscribe(
        res => {
          this.customerfiltter = res.data;
        },
      );

    this._contact.getAssignContactListByid(customerModal)
      .subscribe(
        res => {
          this.customerList = res;
        },
      );

    obj = this;
    this.createform();
  }

  //code by archana 6may 2022
  onChangeCustomers(cust_id: any) {
    this.filtter_customer_id = cust_id;
    $('#example').DataTable().draw();
  }

  //code by archana 6may 2022
  onChangeEmplType(employee_type: any) {
    this.filter_employee_type = employee_type;
    $('#example').DataTable().draw();
  }

  //code by archana 6may 2022
  onChangeStatus(statusValue: any) {
    this.filter_status_value = statusValue;
    $('#example').DataTable().draw();
  }

  //code by Archana
  dataTableForProfessional() {
    this.loaderMode = true;
    this.data = [];
    this.dtOptionsList = {
      pagingType: 'full_numbers',
      pageLength: 100,
      lengthMenu: [25, 50, 100, 150],
      columnDefs: [{
        'targets': [8], // column index (start from 0)
        'orderable': false, // set orderable false for selected columns
      }],
      order: [[2, 'asc']],
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.minNumber = dataTablesParameters.start + 1;
        dataTablesParameters.maxNumber = dataTablesParameters.start + dataTablesParameters.length;
        dataTablesParameters.APIKEY = this.APIKEY;
        dataTablesParameters.user_id = this.user_id;
        dataTablesParameters.company_id = this.company_id;
        dataTablesParameters.status = this.statusValue;
        dataTablesParameters.customer_id = this.filtter_customer_id;
        dataTablesParameters.employee_type = this.filter_employee_type;

        this.http
          .post<DataTablesResponse>(
            environment.api + "/Professional/getProfessionalListAjax",
            dataTablesParameters
          )
          .subscribe((resp: any) => {
            this.loaderMode = false;
            if (resp.status == true) {
              this.data = resp.data;
              console.log("dattaaaa", this.data);
            }
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columns: [{ data: 'professional.professional_id' }, { data: 'professional.pro_unique_id' }, { data: 'professional.professional_name' }, { data: 'professional.empl_type' }, { data: 'professional.phone' }, { data: 'customer_name1' }, { data: 'customer_name2' }, { data: 'professional.status' }, { data: 'action' }]
    };
  }

  //code by Archana 6may 2022
  set_active_id(professional_id, status) {
    this.professional_id = professional_id;
    this.pro_status = status;
  }

  //code by Archana 5/may/2022
  active_professional() {
    const data = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      status: this.pro_status,
      professional_id: this.professional_id,
      company_id: this.company_id,
    }

    this._professional.activeInactiveProfessional(data)
      .subscribe(
        res => {
          this.toastr.success(res.message, 'Success');
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/professional/professional-list/active');
          });

        },
        err => console.log(err)
      );
  }

  //code by Archana 6may2022
  redirectedinto(professional_id) {
    var encrypted = this.EncrDecr.set(localStorage.getItem('key'), professional_id);
    this._router.navigate(["/professional/edit-professional/" + encrypted]);
  }

  redirectedintoview(professional_id) {
    var encrypted = this.EncrDecr.set(localStorage.getItem('key'), professional_id);
    this._router.navigate(["/professional/view-professional/" + encrypted]);
  }

  redirectPage(url) {
    this._router.navigateByUrl('/redirect').then(() => {
      this._router.navigate([url]);
    });
  }

  isCSVFile(file: any) {
    return file.name.endsWith(".csv");
  }

  // 1. upload csv file
  fileChangeListener($event: any): void {
    let text = [];
    this.files = $event.srcElement.files;
    this.fileevent = $event;

    if (this.isCSVFile(this.files[0])) {
      let reader = new FileReader();
      reader.readAsText(this.files[0]);
      reader.onload = () => {
        let csvData = reader.result;
        let csvRecordsArray = (<string>csvData).split(/\r\n|\n/);
        let headersRow = this.getHeaderArray(csvRecordsArray);
        this.recodes = headersRow;

        if (headersRow[0] == "ID#" && headersRow[1] == "Professional Name" && headersRow[2] == "Mobile#" && headersRow[3] == "Email" && headersRow[4] == "DOB" && headersRow[5] == "Empl Type" && headersRow[6] == "Company Name" && headersRow[7] == "Speciality" && headersRow[8] == "Reg Cost Rate" && headersRow[9] == "Reg Sale Rate" && headersRow[10] == "Ot Cost Rate" && headersRow[11] == "Ot Sale Rate" && headersRow[12] == "Dt Cost Rate" && headersRow[13] == "Dt Sale Rate") {
          this.display = 'block';
          this.show_browser_file = false;
        }
        else {
          alert('Import file format is wrong, click sample file for demo csv file');
        }
      };
      reader.onerror = function () {
        console.log('error is occured while reading file!');
      };
    } else {
      $("#txtFileUpload").val('');
      this.toastr.error('Invaild File Format. Only Csv File Are Allowed!');
    }
  }

  hasDuplicates(array) {
    return (new Set(array)).size !== array.length;
  }

  //2. click on confirm button from mapping modal popup
  onSubmit() {
    this.loaderMode = true;
    const select_fact_array = [];
    $(".checkImageAllOpn").each(function () {
      select_fact_array.push($(this).val());
    });

    if (!this.hasDuplicates(select_fact_array)) {
      this.uploadFile(this.files);

      this.display = 'none';
      this.select_field_array = select_fact_array;
      this.csvDataList = select_fact_array;

      if (this.csvDataList != '') {
        this.show_CSV = true;
        this.show_ListData = false;
      }
    }
    else {
      alert('CSV column and database mapping is incorrect');
      //this.redirectPage('/professional/professional-list/active');
    }
  }

  // 3. 
  uploadFile($files: any) {
    if (this.isCSVFile($files[0])) {
      let reader = new FileReader();
      reader.readAsText(this.files[0]);
      reader.onload = () => {
        let csvData = reader.result;
        let csvRecordsArray = (<string>csvData).split(/\r\n|\n/);
        let headersRow = this.getHeaderArray(csvRecordsArray);
        this.fieldrecodes = headersRow;
        // console.log('uploadFile csvRecordsArray ', csvRecordsArray);
        this.csvRecords = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length);
        // console.log('uploadFile csvRecords ', this.csvRecords);
        // alert('aaaaaaaaaaaaa');
        setTimeout(() => {
          this.createform();
        }, 500);

      };
      reader.onerror = function () {
        console.log('error is occured while reading file!');
      };
    } else {
      $("#txtFileUpload").val('');
      this.toastr.error('Invaild File Format. Only Csv File Are Allowed!');
    }
  }

  //GET CSV FILE HEADER COLUMNS
  getHeaderArray(csvRecordsArr: any) {
    let headers = (<string>csvRecordsArr[0]).split(',');
    let headerArray = [];
    for (let j = 0; j < headers.length; j++) {
      headerArray.push(headers[j]);
    }
    return headerArray;
  }

  // 4.
  getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any) {
    let dataArr = [];
    this.tableRowCount = 0;
    for (let i = 1; i < csvRecordsArray.length; i++) {
      //changed this split by deepak 10Feb2022 
      let data = (<string>csvRecordsArray[i]).split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);

      if (data.length == headerLength) {
        this.tableRowCount++;
        let csvRecord: any = [];

        var select_field_array = this.select_field_array;

        csvRecord.Professional_name = data[select_field_array.indexOf("Professional Name")].replace(/\"/g, '');
        csvRecord.pro_unique_id = data[select_field_array.indexOf("ID#")].replace(/\"/g, '');
        csvRecord.Mobile_number = data[select_field_array.indexOf("Mobile#")].replace(/\"/g, '');
        csvRecord.Email = data[select_field_array.indexOf("Email")];
        csvRecord.Dob = data[select_field_array.indexOf("DOB")].replace(/\"/g, '');
        csvRecord.Empl_type = data[select_field_array.indexOf("Empl Type")].replace(/\"/g, '');
        csvRecord.customer_name = data[select_field_array.indexOf("Company Name")].replace(/\"/g, '');
        csvRecord.speciality = data[select_field_array.indexOf("Speciality")].replace(/\"/g, '');
        csvRecord.reg_cost_rate = data[select_field_array.indexOf("Reg Cost Rate")].replace(/\"/g, '');
        csvRecord.reg_sale_rate = data[select_field_array.indexOf("Reg Sale Rate")].replace(/\"/g, '');
        csvRecord.ot_cost_rate = data[select_field_array.indexOf("Ot Cost Rate")].replace(/\"/g, '');
        csvRecord.ot_sale_rate = data[select_field_array.indexOf("Ot Sale Rate")].replace(/\"/g, '');
        csvRecord.dt_cost_rate = data[select_field_array.indexOf("Dt Cost Rate")].replace(/\"/g, '');
        csvRecord.dt_sale_rate = data[select_field_array.indexOf("Dt Sale Rate")].replace(/\"/g, '');

        dataArr.push(csvRecord);
      }
    }
    return dataArr;
  }

  //this function will run auto on initial load
  autoClick() {
    console.log('auto hidden click');
  }

  // 5. on load function when submit the csv
  createform() {
    // alert('asdasd');
    let arr = [];
    // console.log('createform csvRecords ', this.csvRecords);
    // console.log('createform csvRecords length ', this.csvRecords.length);
    if (this.csvRecords.length > 0) {
      const professionaldata = {
        APIKEY: this.APIKEY,
        user_id: this.user_id,
        company_id: this.company_id,
        customer_id: ''
      }

      this._professional.getMainProfessionalListForImport(professionaldata)
        .subscribe(
          res => {
            this.emptyField = false;
            this.rowBoxEmptyMsg = '';
            // console.log(res, "professional data");
            //loop of csv file records
            for (let i = 0; i < this.csvRecords.length; i++) {
              this.csvRecords[i].warning_regcost_rate_class = '';
              this.csvRecords[i].warning_regsale_rate_class = '';
              this.csvRecords[i].warning_otcost_rate_class = '';
              this.csvRecords[i].warning_otsale_rate_class = '';
              this.csvRecords[i].warning_dtcost_rate_class = '';
              this.csvRecords[i].warning_dtsale_rate_class = '';
              this.csvRecords[i].warning_customer_match_class = 'note-sky-blue-box';
              this.csvRecords[i].pro_unique_id_exist = 'note-orange-box';
              // console.log(this.csvRecords[i].pro_unique_id, "1st", this.csvRecords[i].pro_unique_id_exist);
              if (this.csvRecords[i].pro_unique_id == '') {
                this.emptyField = true;
                this.csvRecords[i].pro_unique_id_exist = 'note-red-box';
                // console.log(this.csvRecords[i].pro_unique_id, "if blank", this.csvRecords[i].pro_unique_id_exist)
                this.rowBoxEmptyMsg = "Please Enter ID#";
              }

              if (this.csvRecords[i].Professional_name == '') {
                this.emptyField = true;
                this.rowBoxEmptyMsg = "Please Enter Professional Name";
              }
              if (this.csvRecords[i].customer_name == '') {
                this.emptyField = true;
                this.rowBoxEmptyMsg = "Please Enter Company Name";
              }
              if (this.csvRecords[i].speciality == '') {
                this.emptyField = true;
                this.rowBoxEmptyMsg = "Please Enter Speciality";
              }
              if (this.csvRecords[i].Mobile_number != '') {
                this.csvRecords[i].error_mobnumber_class = '';
                if (isNumber(this.csvRecords[i].Mobile_number) === false) {
                  this.emptyField = true;
                  this.rowBoxEmptyMsg = "Please Enter Correct Mobile Number";
                  this.csvRecords[i].error_mobnumber_class = 'error-mobnumber';
                }
              }
              // if all reg and ot rates are blank
              if ((this.csvRecords[i].reg_cost_rate == '' && this.csvRecords[i].reg_sale_rate == '') && (this.csvRecords[i].ot_cost_rate == '' && this.csvRecords[i].ot_sale_rate == '')) {
                // alert('if');
                if ((this.csvRecords[i].dt_cost_rate != '' && this.csvRecords[i].dt_sale_rate == '')) {
                  // alert('dt sale');
                  this.emptyField = true;
                  this.csvRecords[i].warning_dtsale_rate_class = 'note-red-box';
                  this.rowBoxEmptyMsg = "Please Enter Value On Dt Sale Rate";
                }

                if ((this.csvRecords[i].dt_cost_rate == '' && this.csvRecords[i].dt_sale_rate != '')) {
                  //alert('dt cost');
                  this.emptyField = true;
                  this.csvRecords[i].warning_dtcost_rate_class = 'note-red-box';
                  this.rowBoxEmptyMsg = "Please Enter Value On Dt Cost Rate";
                }
                // both has value dt
                if ((this.csvRecords[i].dt_cost_rate != '' && this.csvRecords[i].dt_sale_rate != '')) {
                  // alert('both');
                  if (parseFloat(this.csvRecords[i].dt_cost_rate) >= parseFloat(this.csvRecords[i].dt_sale_rate)) {
                    // alert('graeter dt');
                    this.emptyField = true;
                    this.csvRecords[i].warning_dtsale_rate_class = 'note-red-box';
                    this.rowBoxEmptyMsg = "Please Enter sale rate greater than cost rate";
                  }
                }
                // if dt cost is 0
                var dtcostrate: any = this.csvRecords[i].dt_cost_rate;
                console.log(parseFloat(dtcostrate), "   -------dtcostrate---      ", parseFloat(dtcostrate));
                if (parseFloat(dtcostrate) <= 0.00) {
                  //alert('dt cost');
                  this.emptyField = true;
                  this.csvRecords[i].warning_dtcost_rate_class = 'note-red-box';
                  this.rowBoxEmptyMsg = "Please Enter Value Greater Than 0 On Dt Cost Rate";
                }
                var dtsalerate: any = this.csvRecords[i].dt_sale_rate;
                console.log(parseFloat(dtsalerate), "   ----------      ", parseFloat(dtsalerate));
                if (parseFloat(dtsalerate) <= 0.00) {
                  //alert('dt cost');
                  this.emptyField = true;
                  this.csvRecords[i].warning_dtsale_rate_class = 'note-red-box';
                  this.rowBoxEmptyMsg = "Please Enter Value Greater Than 0 On Dt Sale Rate";
                }
                // end

                this.emptyField = true;
                this.csvRecords[i].warning_regcost_rate_class = 'note-red-box';
                this.csvRecords[i].warning_regsale_rate_class = 'note-red-box';
                this.csvRecords[i].warning_otcost_rate_class = 'note-red-box';
                this.csvRecords[i].warning_otsale_rate_class = 'note-red-box';
                this.rowBoxEmptyMsg = "Please Enter Value On Reg Cost Rate or OT Cost Rate";
                // alert('hiii');
              }
              else {
                // alert('else  fger');
                if (this.csvRecords[i].reg_cost_rate != '' && this.csvRecords[i].reg_sale_rate == '') {
                  // alert('sale reg');
                  this.emptyField = true;
                  this.csvRecords[i].warning_regsale_rate_class = 'note-red-box';
                  this.rowBoxEmptyMsg = "Please Enter Value On Reg Sale Rate";
                }
                if (this.csvRecords[i].reg_sale_rate != '' && this.csvRecords[i].reg_cost_rate == '') {
                  // alert('reg cost');
                  this.emptyField = true;
                  this.csvRecords[i].warning_regcost_rate_class = 'note-red-box';
                  this.rowBoxEmptyMsg = "Please Enter Value On Reg Cost Rate";
                }
                if (this.csvRecords[i].reg_sale_rate != '' && this.csvRecords[i].reg_cost_rate != '') {
                  // alert('reg bith');
                  if (parseFloat(this.csvRecords[i].reg_sale_rate) <= parseFloat(this.csvRecords[i].reg_cost_rate)) {
                    // alert('reg gret')
                    this.emptyField = true;
                    this.csvRecords[i].warning_regsale_rate_class = 'note-red-box';
                    this.rowBoxEmptyMsg = "Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate";
                  }
                }
                // if reg sale rate 0
                var regsalerate = this.csvRecords[i].reg_sale_rate;
                console.log(parseFloat(regsalerate), " regsalerate ", regsalerate);
                if (parseFloat(regsalerate) <= 0) {
                  // alert('sale reg');
                  this.emptyField = true;
                  this.csvRecords[i].warning_regsale_rate_class = 'note-red-box';
                  this.rowBoxEmptyMsg = "Please Enter Value Greater Than 0 On Reg Sale Rate";
                }
                console.log(parseFloat(regcostrate), " regcostrate ", regcostrate, parseFloat(regcostrate));
                var regcostrate = this.csvRecords[i].reg_cost_rate;
                if (parseFloat(regcostrate) <= 0) {
                  // alert('reg cost');
                  this.emptyField = true;
                  this.csvRecords[i].warning_regcost_rate_class = 'note-red-box';
                  this.rowBoxEmptyMsg = "Please Enter Value Greater Than 0 On Reg Cost Rate";
                }
                //end

                if (this.csvRecords[i].ot_cost_rate != '' && this.csvRecords[i].ot_sale_rate == '') {
                  // alert('ot sale')
                  this.emptyField = true;
                  this.csvRecords[i].warning_otsale_rate_class = 'note-red-box';
                  this.rowBoxEmptyMsg = "Please Enter Value On Ot Sale Rate";
                }
                if (this.csvRecords[i].ot_sale_rate != '' && this.csvRecords[i].ot_cost_rate == '') {
                  // alert('ot cost')
                  this.emptyField = true;
                  this.csvRecords[i].warning_otcost_rate_class = 'note-red-box';
                  this.rowBoxEmptyMsg = "Please Enter Value On Ot Cost Rate";
                }
                if (this.csvRecords[i].ot_sale_rate != '' && this.csvRecords[i].ot_cost_rate != '') {
                  // alert('ot both')
                  if (parseFloat(this.csvRecords[i].ot_sale_rate) <= parseFloat(this.csvRecords[i].ot_cost_rate)) {
                    // alert('ot gere')
                    this.emptyField = true;
                    this.csvRecords[i].warning_otsale_rate_class = 'note-red-box';
                    this.rowBoxEmptyMsg = "Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate";
                  }
                }
                // ot rates 0

                var otsalerate = this.csvRecords[i].ot_sale_rate;
                console.log(parseFloat(otsalerate), " otsalerate ", otsalerate);
                if (parseFloat(otsalerate) <= 0.00) {
                  // alert('ot sale')
                  this.emptyField = true;
                  this.csvRecords[i].warning_otsale_rate_class = 'note-red-box';
                  this.rowBoxEmptyMsg = "Please Enter Value Greater than 0 On Ot Sale Rate";
                }
                var otcostrate = this.csvRecords[i].ot_cost_rate;
                console.log(parseFloat(otcostrate), "   otcostrate      ", parseFloat(otcostrate));
                if (parseFloat(otcostrate) <= 0.00) {
                  // alert('ot cost')
                  this.emptyField = true;
                  this.csvRecords[i].warning_otcost_rate_class = 'note-red-box';
                  this.rowBoxEmptyMsg = "Please Enter Value Greater than 0  On Ot Cost Rate";
                }
                // end
                if ((this.csvRecords[i].dt_cost_rate != '' && this.csvRecords[i].dt_sale_rate == '')) {
                  // alert('dt sale')
                  this.emptyField = true;
                  this.csvRecords[i].warning_dtsale_rate_class = 'note-red-box';
                  this.rowBoxEmptyMsg = "Please Enter Value On Dt Sale Rate";
                }

                if ((this.csvRecords[i].dt_cost_rate == '' && this.csvRecords[i].dt_sale_rate != '')) {
                  // alert('dt cost')
                  this.emptyField = true;
                  this.csvRecords[i].warning_dtcost_rate_class = 'note-red-box';
                  this.rowBoxEmptyMsg = "Please Enter Value On Dt Cost Rate";
                }

                if (this.csvRecords[i].dt_cost_rate != '' && this.csvRecords[i].dt_sale_rate != '') {
                  // alert('ji');
                  if (parseFloat(this.csvRecords[i].dt_cost_rate) >= parseFloat(this.csvRecords[i].dt_sale_rate)) {
                    // alert('kkkk');
                    this.emptyField = true;
                    this.csvRecords[i].warning_dtsale_rate_class = 'note-red-box';
                    this.rowBoxEmptyMsg = "Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate";
                  }
                }
                // if dt cost is 0
                var dtcostrate: any = this.csvRecords[i].dt_cost_rate;
                console.log(parseFloat(dtcostrate), " dtcostrate ", dtcostrate);
                if (parseFloat(dtcostrate) <= 0.00) {
                  //alert('dt cost');
                  this.emptyField = true;
                  this.csvRecords[i].warning_dtcost_rate_class = 'note-red-box';
                  this.rowBoxEmptyMsg = "Please Enter Value Greater Than 0 On Dt Cost Rate";
                }
                var dtsalerate: any = this.csvRecords[i].dt_sale_rate;
                if (parseFloat(dtsalerate) <= 0.00) {
                  //alert('dt cost');
                  this.emptyField = true;
                  this.csvRecords[i].warning_dtsale_rate_class = 'note-red-box';
                  this.rowBoxEmptyMsg = "Please Enter Value Greater Than 0 On Dt Sale Rate";
                }
                console.log(parseFloat(dtsalerate), "   ----------      ", parseFloat(dtsalerate));
              }
              this.professionalList = res.data;
              this.professionalList.forEach(item => {
                for (var j = 0; j < item.product_line_items.length; j++) {

                  console.log((item.product_line_items[j].company_name.toUpperCase()) == (this.csvRecords[i].customer_name.toUpperCase()));

                  console.log((item.product_line_items[j].company_name.toUpperCase()));
                  console.log((this.csvRecords[i].customer_name.toUpperCase()));

                  if ((item.product_line_items[j].company_name.toUpperCase()) == (this.csvRecords[i].customer_name.toUpperCase())) {
                    this.csvRecords[i].warning_customer_match_class = '';
                    // console.log('customer exists');
                    //get array index number after split comma separated record
                    item.product_line_items[j].reg_index = item.product_line_items[j].work_type.split(',').findIndex(wt => wt == 'Regular');

                    item.product_line_items[j].ot_index = item.product_line_items[j].work_type.split(',').findIndex(wt => wt == 'Overtime');

                    item.product_line_items[j].dt_index = item.product_line_items[j].work_type.split(',').findIndex(wt => wt == 'Double');

                    if ((item.product_line_items[j].pro_unique_id).trim().toUpperCase() == (this.csvRecords[i].pro_unique_id).trim().toUpperCase()) {

                      if (item.product_line_items[j].speciality.toUpperCase() === this.csvRecords[i].speciality.toUpperCase()) {
                        // console.log('department h ', item.product_line_items[j].speciality);
                        if (item.product_line_items[j].reg_index !== -1) {
                          if (parseFloat(this.csvRecords[i].reg_cost_rate).toFixed(2) != item.product_line_items[j].cost_rate.split(',')[item.product_line_items[j].reg_index]) {
                            this.isExistingRateMatch = false; //rate not matched
                            this.csvRecords[i].warning_regcost_rate_class = 'note-yellow-box';
                          }
                          if (parseFloat(this.csvRecords[i].reg_sale_rate).toFixed(2) != item.product_line_items[j].sale_rate.split(',')[item.product_line_items[j].reg_index]) {
                            this.isExistingRateMatch = false;
                            this.csvRecords[i].warning_regsale_rate_class = 'note-yellow-box';
                          }
                        }

                        if (item.product_line_items[j].ot_index !== -1) {
                          if (parseFloat(this.csvRecords[i].ot_cost_rate).toFixed(2) != item.product_line_items[j].cost_rate.split(',')[item.product_line_items[j].ot_index]) {
                            this.isExistingRateMatch = false;
                            this.csvRecords[i].warning_otcost_rate_class = 'note-yellow-box';
                          }
                          if (parseFloat(this.csvRecords[i].ot_sale_rate).toFixed(2) != item.product_line_items[j].sale_rate.split(',')[item.product_line_items[j].ot_index]) {
                            this.isExistingRateMatch = false;
                            this.csvRecords[i].warning_otsale_rate_class = 'note-yellow-box';
                          }
                        }
                        if (item.product_line_items[j].dt_index !== -1) {
                          if (parseFloat(this.csvRecords[i].dt_cost_rate).toFixed(2) != item.product_line_items[j].cost_rate.split(',')[item.product_line_items[j].dt_index]) {
                            this.isExistingRateMatch = false;
                            this.csvRecords[i].warning_dtcost_rate_class = 'note-yellow-box';
                          }
                          if (parseFloat(this.csvRecords[i].dt_sale_rate).toFixed(2) != item.product_line_items[j].sale_rate.split(',')[item.product_line_items[j].dt_index]) {
                            this.isExistingRateMatch = false;
                            this.csvRecords[i].warning_dtsale_rate_class = 'note-yellow-box';
                          }
                        }
                      } //item.speciality match if condition end
                    }//item professional id test
                  }   // customer name match if condition
                  if ((item.product_line_items[j].pro_unique_id).trim().toUpperCase() == (this.csvRecords[i].pro_unique_id).trim().toUpperCase()) {
                    this.csvRecords[i].pro_unique_id_exist = '';
                    // console.log(this.csvRecords[i].pro_unique_id, "if  exists", this.csvRecords[i].pro_unique_id_exist)
                  } // pro unique id match if condition end
                } //item.product_line_items loop end
              }); //professionalList loop end

              // console.log('isExistingRateMatch ', this.isExistingRateMatch);

              if (this.isExistingRateMatch == true) {
                this.finalSaveSubmitMsg = 'Do you want to save information.';
              } else {
                this.finalSaveSubmitMsg = 'Rates are different. Do you want to save with rate changes.';
              }
              // console.log(this.csvRecords[i])
              arr.push(this.BuildFormDynamic(this.csvRecords[i]))
              // console.log(this.csvRecords[i]);
            } //csvRecords loop end

            this.CSV_Datalist = this.fb.group({
              ClassDetails: this.fb.array(arr)
            });

            //this is auto click for find out red box error on initial load
            setTimeout(() => {
              if (document.getElementById('auto_trigger')) {
                let element: HTMLElement = document.getElementById('auto_trigger') as HTMLElement;
                element.click();
              }
            }, 10);

            this.loaderMode = false;
          }
        );

    } else {
      this.CSV_Datalist = this.fb.group({
        ClassDetails: this.fb.array(arr)
      });

      this.loaderMode = false;
    }

  }

  BuildFormDynamic(data): FormGroup {
    return this.fb.group({
      Professional_name: [data.Professional_name],
      pro_unique_id: [data.pro_unique_id],
      Mobile_number: [data.Mobile_number],
      Email: [data.Email],
      Dob: [data.Dob],
      Empl_type: [data.Empl_type],
      customer_name: [data.customer_name],
      speciality: [data.speciality],
      reg_cost_rate: [data.reg_cost_rate],
      reg_sale_rate: [data.reg_sale_rate],
      ot_cost_rate: [data.ot_cost_rate],
      ot_sale_rate: [data.ot_sale_rate],
      dt_cost_rate: [data.dt_cost_rate],
      dt_sale_rate: [data.dt_sale_rate],
      error_mobnumber_class: [data.error_mobnumber_class],
      warning_regcost_rate_class: [data.warning_regcost_rate_class],
      warning_regsale_rate_class: [data.warning_regsale_rate_class],
      warning_otcost_rate_class: [data.warning_otcost_rate_class],
      warning_otsale_rate_class: [data.warning_otsale_rate_class],
      warning_dtcost_rate_class: [data.warning_dtcost_rate_class],
      warning_dtsale_rate_class: [data.warning_dtsale_rate_class],
      warning_customer_match_class: [data.warning_customer_match_class],
      pro_unique_id_exist: [data.pro_unique_id_exist]
    })
  }

  // 6. final save data submit
  saveImportData() {
    this.loaderMode = true;

    const data = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      importData: this.CSV_Datalist.value,
    }

    this._professional.saveImportProfessional(data)
      .subscribe(
        res => {
          this.loaderMode = false;
          this.toastr.success(res.message, 'Success');
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/professional/professional-list/active');
          });
        },
        err => {
          this.loaderMode = false;
          console.log(err)
        }
      );
  }

  exportProfessionalCsv() {
    this.loaderMode = true;
    const dataModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: this.statusValue,
    }

    //get mobile folder list 
    this._professional.exportProfessionalCsv(dataModal)
      .subscribe(
        res => {
          this.loaderMode = false;
          this.customerCsvPath = res.url;
          this.forceDownload(this.customerCsvPath);
        },
      );
  }

  exportToProfessionalCsv() {
    this.loaderMode = true;
    const dataModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: this.statusValue,
    }

    //get mobile folder list 
    this._professional.exportToProfessionalCsv(dataModal)
      .subscribe(
        res => {
          this.loaderMode = false;
          this.customerCsvPathWithoutSpaces = res.url;
          this.forceDownload(this.customerCsvPathWithoutSpaces);
        },
      );
  }

  forceDownload(url) {
    var fileName = url.substring(url.lastIndexOf("/") + 1, url.length);
    this.http.get(url, { responseType: 'blob' }).subscribe(
      (d: any) => {
        saveAs(d, fileName);
      },
      (err: any) => {
        console.log("error", err)
      }
    )

  }

  //if change any value on import table list
  changevalue($event, rowindex) {
    var getIdName = $event.target.id;
    var currentRowId = $("#" + getIdName);
    if (currentRowId.val() == '') {
      if (getIdName == 'mobileNumber' + rowindex) {
        // console.log('mobileNumber id match');
        currentRowId.css("background", "");
        currentRowId.removeClass("error-mobnumber");
      } else {
        currentRowId.css("background", "#fd5c63");
      }
    } else {
      // console.log('else');
      currentRowId.css("background", "");
    }

    this.checkErrorInAllRow();
    // comented because it will be used only when customer changes
    // if (currentRowId.val() != '') {
    //   if(getIdName == 'customerNo' + rowindex) {
    //     this.custChange($event, rowindex);
    //   }
    // }
    // commented only for prounique id check
    // if (currentRowId.val() != '') {
    //   if (getIdName == 'proUniqueId' + rowindex) {
    //     this.proIdChange($event, rowindex);
    //   }
    // }

  }

  checkErrorInAllRow() {
    this.emptyField = false;
    this.rowBoxEmptyMsg = '';
    // alert("check errror");
    for (var i = 0; i < this.tableRowCount; i++) {
      $("#regCostRate" + i).css("background", "");
      $("#regSaleRate" + i).css("background", "");
      $("#otCostRate" + i).css("background", "");
      $("#otSaleRate" + i).css("background", "");
      $("#dtSaleRate" + i).css("background", "");
      $("#dtCostRate" + i).css("background", "");
      $("#regCostRate" + i).removeClass("note-red-box");
      $("#regSaleRate" + i).removeClass("note-red-box");
      $("#otCostRate" + i).removeClass("note-red-box");
      $("#otSaleRate" + i).removeClass("note-red-box");
      $("#dtSaleRate" + i).removeClass("note-red-box");
      $("#dtCostRate" + i).removeClass("note-red-box");
      // alert('aaaaaaaaaaaaaaa');
      if ($("#proUniqueId" + i).val() == '') {
        this.emptyField = true;
        this.rowBoxEmptyMsg = "Please Enter ID#";
        $("#proUniqueId" + i).css("background", "#fd5c63");
      }
      if ($("#professionalName" + i).val() == '') {
        this.emptyField = true;
        this.rowBoxEmptyMsg = "Please Enter Professional Name";
        $("#professionalName" + i).css("background", "#fd5c63");
      }
      if ($("#customerNo" + i).val() == '') {
        this.emptyField = true;
        this.rowBoxEmptyMsg = "Please Enter Company Name";
        $("#customerNo" + i).css("background", "#fd5c63");
      }
      if ($("#speciality" + i).val() == '') {
        this.emptyField = true;
        this.rowBoxEmptyMsg = "Please Enter Speciality";
        $("#speciality" + i).css("background", "#fd5c63");
      }
      //added 06/06/2023 if regular ot are blank
      if (($("#regCostRate" + i).val() == '' && $("#regSaleRate" + i).val() == '') && ($("#otCostRate" + i).val() == '' && $("#otSaleRate" + i).val() == '')) {
        // console.log('if 4 blank');
        if (($("#dtCostRate" + i).val() != '' && $("#dtSaleRate" + i).val() == '')) {
          this.emptyField = true;
          $("#dtSaleRate" + i).removeClass("note-yellow-box");
          $("#dtSaleRate" + i).css("background", "#fd5c63");
          this.rowBoxEmptyMsg = "Please Enter Value On Dt Sale Rate";
        }
        // dt rate 0
        if ($("#dtSaleRate" + i).val() == '0' || $("#dtSaleRate" + i).val() == 0) {
          this.emptyField = true;
          $("#dtSaleRate" + i).removeClass("note-yellow-box");
          $("#dtSaleRate" + i).css("background", "#fd5c63");
          this.rowBoxEmptyMsg = "Please Enter Value Greater than 0 On Dt Sale Rate";
        }
        if (($("#dtCostRate" + i).val() == '0' || $("#dtCostRate" + i).val() == 0)) {
          this.emptyField = true;
          $("#dtCostRate" + i).removeClass("note-yellow-box");
          $("#dtCostRate" + i).css("background", "#fd5c63");
          this.rowBoxEmptyMsg = "Please Enter Value On Dt Cost Rate";
        }
        // end
        if (($("#dtCostRate" + i).val() == '' && $("#dtSaleRate" + i).val() != '')) {
          this.emptyField = true;
          $("#dtCostRate" + i).removeClass("note-yellow-box");
          $("#dtCostRate" + i).css("background", "#fd5c63");
          this.rowBoxEmptyMsg = "Please Enter Value On Dt Cost Rate";
        }
        // if both dt has value
        if (($("#dtCostRate" + i).val() != '' && $("#dtSaleRate" + i).val() != '')) {
          var saledt: any = $("#dtSaleRate" + i).val();
          var costdt: any = $("#dtCostRate" + i).val();
          if (parseFloat(costdt) >= parseFloat(saledt)) {
            this.emptyField = true;
            $("#dtSaleRate" + i).removeClass("note-yellow-box");
            $("#dtSaleRate" + i).css("background", "#fd5c63");
            this.rowBoxEmptyMsg = "Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate";
          }
        }
        this.emptyField = true;
        $("#regCostRate" + i).css("background", "#fd5c63");
        $("#regSaleRate" + i).css("background", "#fd5c63");
        $("#otCostRate" + i).css("background", "#fd5c63");
        $("#otSaleRate" + i).css("background", "#fd5c63");
        this.rowBoxEmptyMsg = "Please Enter Value On Reg Cost Rate or OT Cost Rate";
      }
      else {
        // if reg and ot are not blank
        // console.log('else has value');
        if ($("#regCostRate" + i).val() != '' && $("#regSaleRate" + i).val() == '') {
          this.emptyField = true;
          $("#regSaleRate" + i).removeClass("note-yellow-box");
          $("#regSaleRate" + i).css("background", "#fd5c63");
          this.rowBoxEmptyMsg = "Please Enter Value On Reg Sale Rate";
        }
        if ($("#regSaleRate" + i).val() != '' && $("#regCostRate" + i).val() == '') {
          this.emptyField = true;
          $("#regCostRate" + i).removeClass("note-yellow-box");
          $("#regCostRate" + i).css("background", "#fd5c63");
          this.rowBoxEmptyMsg = "Please Enter Value On Reg Cost Rate";
        }
        // if reg both exists and check 0 and less tahn sale
        if ($("#regSaleRate" + i).val() != '' && $("#regCostRate" + i).val() != '') {
          var salereg: any = $("#regSaleRate" + i).val();
          var costreg: any = $("#regCostRate" + i).val();
          if (parseFloat(salereg) <= parseFloat(costreg)) {
            // console.log('reg gretae')
            this.emptyField = true;
            $("#regSaleRate" + i).removeClass("note-yellow-box");
            $("#regSaleRate" + i).css("background", "#fd5c63");
            this.rowBoxEmptyMsg = "Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate";
          }
        }
        // end
        // reg rate 0
        var regsalerate: any = $("#regSaleRate" + i).val();
        console.log(parseFloat(regsalerate), " regsalerate ", regsalerate);
        if (parseFloat(regsalerate) <= 0) {
          // alert('sale reg');
          this.emptyField = true;
          $("#regSaleRate" + i).removeClass("note-yellow-box");
          $("#regSaleRate" + i).css("background", "#fd5c63");
          this.rowBoxEmptyMsg = "Please Enter Value Greater Than 0 On Reg Sale Rate";
        }
        var regcostrate: any = $("#regCostRate" + i).val();
        if (parseFloat(regcostrate) <= 0) {
          // alert('reg cost');
          this.emptyField = true;
          $("#regCostRate" + i).removeClass("note-yellow-box");
          $("#regCostRate" + i).css("background", "#fd5c63");
          this.rowBoxEmptyMsg = "Please EnterValue Greater Than 0 On Reg Cost Rate";
        }
        // end
        if ($("#otCostRate" + i).val() != '' && $("#otSaleRate" + i).val() == '') {
          this.emptyField = true;
          // this.csvRecords[i].warning_otsale_rate_class = 'note-red-box';
          $("#otSaleRate" + i).removeClass("note-yellow-box");
          $("#otSaleRate" + i).css("background", "#fd5c63");
          this.rowBoxEmptyMsg = "Please Enter Value On Ot Sale Rate";
        }
        if ($("#otSaleRate" + i).val() != '' && $("#otCostRate" + i).val() == '') {
          this.emptyField = true;
          // this.csvRecords[i].warning_otcost_rate_class = 'note-red-box';
          $("#otCostRate" + i).removeClass("note-yellow-box");
          $("#otCostRate" + i).css("background", "#fd5c63");
          this.rowBoxEmptyMsg = "Please Enter Value On Ot Cost Rate";
        }
        // if ot both exists and check 0 and less tahn sale
        if ($("#otSaleRate" + i).val() != '' && $("#otCostRate" + i).val() != '') {
          var saleot: any = $("#otSaleRate" + i).val();
          var costot: any = $("#otCostRate" + i).val();
          if (parseFloat(saleot) <= parseFloat(costot)) {
            this.emptyField = true;
            $("#otSaleRate" + i).removeClass("note-yellow-box");
            $("#otSaleRate" + i).css("background", "#fd5c63");
            this.rowBoxEmptyMsg = "Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate";
          }
        }
        // ot rate 0
        var otsalerate: any = $("#otSaleRate" + i).val();
        console.log(parseFloat(otsalerate), " otsalerate ", otsalerate);
        if (parseFloat(otsalerate) <= 0.00) {
          // alert('ot sale')
          this.emptyField = true;
          $("#otSaleRate" + i).removeClass("note-yellow-box");
          $("#otSaleRate" + i).css("background", "#fd5c63");
          this.rowBoxEmptyMsg = "Please Enter Value Greater than 0 On Ot Sale Rate";
        }
        var otcostrate: any = $("#otCostRate" + i).val();
        if (parseFloat(otcostrate) <= 0.00) {
          // alert('ot cost')
          this.emptyField = true;
          $("#otCostRate" + i).removeClass("note-yellow-box");
          $("#otCostRate" + i).css("background", "#fd5c63");
          this.rowBoxEmptyMsg = "Please Enter Value Greater than 0  On Ot Cost Rate";
        }
        // end
        if (($("#dtCostRate" + i).val() != '' && $("#dtSaleRate" + i).val() == '')) {
          this.emptyField = true;
          // this.csvRecords[i].warning_dtsale_rate_class = 'note-red-box';
          $("#dtSaleRate" + i).removeClass("note-yellow-box");
          $("#dtSaleRate" + i).css("background", "#fd5c63");
          this.rowBoxEmptyMsg = "Please Enter Value On Dt Sale Rate";
        }

        if (($("#dtCostRate" + i).val() == '' && $("#dtSaleRate" + i).val() != '')) {
          this.emptyField = true;
          // this.csvRecords[i].warning_dtcost_rate_class = 'note-red-box';
          $("#dtCostRate" + i).removeClass("note-yellow-box");
          $("#dtCostRate" + i).css("background", "#fd5c63");
          this.rowBoxEmptyMsg = "Please Enter Value On Dt Cost Rate";
        }
        // if dt both exists and check 0 and less tahn sale
        if (($("#dtCostRate" + i).val() != '' && $("#dtSaleRate" + i).val() != '')) {
          var saledt: any = $("#dtSaleRate" + i).val();
          var costdt: any = $("#dtCostRate" + i).val();
          if (parseFloat(costdt) >= parseFloat(saledt)) {
            this.emptyField = true;
            $("#dtSaleRate" + i).removeClass("note-yellow-box");
            $("#dtSaleRate" + i).css("background", "#fd5c63");
            this.rowBoxEmptyMsg = "Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate";
          }
        }
        // dt rates 0
        var dtcostrate: any = $("#dtCostRate" + i).val();
        console.log(parseFloat(dtcostrate), " dtcostrate ", dtcostrate);
        if (parseFloat(dtcostrate) <= 0.00) {
          //alert('dt cost');
          this.emptyField = true;
          $("#dtCostRate" + i).removeClass("note-yellow-box");
          $("#dtCostRate" + i).css("background", "#fd5c63");
          this.rowBoxEmptyMsg = "Please Enter Value Greater Than 0 On Dt Cost Rate";
        }
        var dtsalerate: any = $("#dtSaleRate" + i).val();
        if (parseFloat(dtsalerate) <= 0.00) {
          //alert('dt cost');
          this.emptyField = true;
          $("#dtCostRate" + i).removeClass("note-yellow-box");
          $("#dtCostRate" + i).css("background", "#fd5c63");
          this.rowBoxEmptyMsg = "Please Enter Value Greater Than 0 On Dt Sale Rate";
        }
        // end
      }
      //end
      if ($("#mobileNumber" + i).val() != '') {
        // console.log('not blank');
        if (isNumber($("#mobileNumber" + i).val()) === false) {
          // console.log('alphbate h');
          this.emptyField = true;
          this.rowBoxEmptyMsg = "Please Enter Correct Mobile Number";
          $("#mobileNumber" + i).css("background", "#fd5c63");
        } else {
          // console.log('number h');
          $("#mobileNumber" + i).css("background", "");
          $("#mobileNumber" + i).removeClass("error-mobnumber");
        }
      } //mobile no condition
    } //for loop end here
  }

  onlynumber(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      // console.log('if');
      this.emptyField = false;
      return false;
    } else {
      // console.log('else');
      return true;
    }
  }
  custChange(evt, i) {
    console.log('cust change fun')
    var count = 0;
    // this.customerList.forEach(element => {
    this.professionalList.forEach(element => {
      element.product_line_items.forEach(element => {
        // console.log(element.company_name, "    ", $("#customerNo" + i).val())
        var compname: any = $("#customerNo" + i).val();
        if (compname.toUpperCase() == element.company_name.toUpperCase()) {
          // console.log('if matched cust name');
          // alert(' hhh ');
          var proId: any = $("#proUniqueId" + i).val();
          if (proId.toUpperCase() == element.pro_unique_id.toUpperCase()) {
            $("#customerNo" + i).css("background", "");
            $("#customerNo" + i).removeClass("note-sky-blue-box");
            count++;
          }
        }
      });
    })
    if (count == 0) {
      // console.warn('cust no');
      // alert('jjj');
      $("#customerNo" + i).css("background", "#87ceeb");
    }
  }

  proIdChange(evt, i) {
    console.log('proid change fun')
    var countpro = 0;
    this.professionalList.forEach(element => {
      var proId: any = $("#proUniqueId" + i).val();
      if (proId.toUpperCase() == element.pro_unique_id.toUpperCase()) {
        $("#proUniqueId" + i).removeClass("note-orange-box");
        $("#proUniqueId" + i).css("background", "");
        countpro++;
        element.product_line_items.forEach(element => {
          // -------------------------------
          element.reg_index = element.work_type.split(',').findIndex(wt => wt == 'Regular');

          element.ot_index = element.work_type.split(',').findIndex(wt => wt == 'Overtime');

          element.dt_index = element.work_type.split(',').findIndex(wt => wt == 'Double');
          var specialityCheck: any = $("#speciality" + i).val();
          console.error(element.speciality, " ==  ", $("#speciality" + i).val());
          if (element.speciality.toUpperCase() == specialityCheck.toUpperCase()) {

            if (element.reg_index != -1) {
              var reg_cost_ratevar: any = $("#regCostRate" + i).val();
              if (parseFloat(reg_cost_ratevar).toFixed(2) != element.cost_rate.split(',')[element.reg_index]) {
                console.log('reg cost rate matched');
                this.isExistingRateMatch = false; //rate not matched
                $("#regCostRate" + i).css("background", "#fcff2b");
              }
              var reg_sale_ratevar: any = $("#regSaleRate" + i).val();
              if (parseFloat(reg_sale_ratevar).toFixed(2) != element.sale_rate.split(',')[element.reg_index]) {
                console.log('reg sale rate matched');
                this.isExistingRateMatch = false;
                $("#regSaleRate" + i).css("background", "#fcff2b");
              }
            }
            console.log('ot_index ', element.ot_index);
            if (element.ot_index != -1) {
              var ot_cost_ratevar: any = $("#otCostRate" + i).val();
              if (parseFloat(ot_cost_ratevar).toFixed(2) != element.cost_rate.split(',')[element.ot_index]) {
                console.log(' ot cost rate matched if');
                this.isExistingRateMatch = false;
                $("#otCostRate" + i).css("background", "#fcff2b");
              }
              var ot_sale_ratevar: any = $("#otSaleRate" + i).val();
              if (parseFloat(ot_sale_ratevar).toFixed(2) != element.sale_rate.split(',')[element.ot_index]) {
                console.log(' ot sale rate matched if',);
                this.isExistingRateMatch = false;
                $("#otSaleRate" + i).css("background", "#fcff2b");

              }
            }

            console.log('element.dt_index', element.dt_index);

            if (element.dt_index != -1) {
              var dt_cost_ratevar: any = $("#dtCostRate" + i).val();
              if (parseFloat(dt_cost_ratevar).toFixed(2) != element.cost_rate.split(',')[element.dt_index]) {
                console.log('dty costif');
                this.isExistingRateMatch = false;
                $("#dtCostRate" + i).css("background", "#fcff2b");
              }
              var dt_sale_ratevar: any = $("#dtSaleRate" + i).val();
              if (parseFloat(dt_sale_ratevar).toFixed(2) != element.sale_rate.split(',')[element.dt_index]) {
                console.log(' dt sale if',);
                this.isExistingRateMatch = false;
                $("#dtSaleRate" + i).css("background", "#fcff2b");
              }
            }
          }
          // =====================
        });
      }
    });
    if (this.isExistingRateMatch == true) {
      this.finalSaveSubmitMsg = 'Do you want to save information.';
    } else {
      this.finalSaveSubmitMsg = 'Rates are different. Do you want to save with rate changes.';
    }
    if (countpro == 0) {
      console.warn('pro id no');
      $("#proUniqueId" + i).css("background", "#ffa500");
    }
  }

}

